export default "console.log(\"hello world\");"